import React from 'react'

const ModalHeader = ({ children }) => {
  return (
    <div className='modal-header'>{children}</div>
  )
}

export default ModalHeader
